module.exports = __webpack_public_path__ + "img/mstile-150x150.058a3335.png";